module.exports = __webpack_public_path__ + "img/idphoto_null@3x.d103aa5f.png";